import { render, staticRenderFns } from "./default-navigation.vue?vue&type=template&id=00fa3873&scoped=true&"
import script from "./default-navigation.vue?vue&type=script&lang=ts&"
export * from "./default-navigation.vue?vue&type=script&lang=ts&"
import style0 from "./default-navigation.vue?vue&type=style&index=0&id=00fa3873&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00fa3873",
  null
  
)

export default component.exports